import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';

/**
 * Whether the device can reach the network, from react-query's onlineManager.
 *
 * The onlineManager is fed by the app (NetInfo on native); with nothing wired,
 * as on web, it reports online. That is why the server snapshot is `true`.
 */
export const useOnlineStatus = () => {
  const isOnline = useSyncExternalStore(
    onlineManager.subscribe.bind(onlineManager),
    () => onlineManager.isOnline(),
    () => true
  );

  return { isOnline };
};
